import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, ElementRef, HostListener, inject, input, InputSignal, viewChild } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { asyncScheduler, debounceTime, Subject } from 'rxjs';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
  ],
  selector: 'offers-navigation-buttons',
  templateUrl: './navigation-buttons.component.html',
  styleUrl: './navigation-buttons.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class OffersNavigationButtonsComponent{
    public offersList: InputSignal<HTMLElement> = input.required<HTMLElement>();
    public translate = inject(TranslateService);
    public debouncer: Subject<string> = new Subject<string>();
    public buttonNext = viewChild.required<ElementRef>('buttonNext');
    public buttonPrev = viewChild.required<ElementRef>('buttonPrev');
    public navigationButtonContainer = viewChild.required<ElementRef>('navigationButtonContainer');
    public inputDebouncer$: any;
    public scrollWidth = 270

    @HostListener('window:resize', ['$event'])
    onResize(event: Event) {
      this.emitDebounce(event)
    }

    ngAfterViewInit() {
      this.inputDebouncer$ = this.debouncer.pipe(debounceTime(50, asyncScheduler)).subscribe((value) => { this.checkOnScroll() });
      this.offersList()?.addEventListener('scroll', this.emitDebounce.bind(this));
      setTimeout(() => {
        this.checkNavigationButtons();
      }, 0);
    }

    emitDebounce(event: Event) {
      this.debouncer.next("");
    }
   
    goPrev(){
      if(!this.offersList()) return;
      this.offersList().scrollLeft -= this.scrollWidth;
    }

    goNext(){
      if(!this.offersList()) return;
      this.offersList().scrollLeft += this.scrollWidth;
    }

    checkOnScroll(){
      if (!this.buttonNext() || !this.buttonPrev()) return;
      this.checkNavigationButtons();
      const nextButtonRemainWidth = ((this.offersList()?.scrollLeft + this.offersList()?.clientWidth) >= (this.offersList()?.scrollWidth)) 
      const leftButtonRemainWidth = this.offersList() && (this.offersList()?.scrollLeft <= 0)
      this.buttonNext().nativeElement.style.opacity =  this.offersList() && nextButtonRemainWidth ? this.disableNextButton() : this.enableNextButton()
      this.buttonPrev().nativeElement.style.opacity =  this.offersList() && leftButtonRemainWidth ? this.disablePrevButton() : this.enablePrevButton()
    }

    checkNavigationButtons(){
      const shoudHideNavigationButtons = (this.offersList()?.clientWidth == this.offersList()?.scrollWidth)
      this.navigationButtonContainer().nativeElement.style.opacity = shoudHideNavigationButtons ? '0' : '1'
    }

    disableNextButton(){
      if (!this.buttonNext()) return;
      if (!this.buttonNext().nativeElement.classList.contains('disabled'))
        this.buttonNext().nativeElement.classList.add('disabled')
    }

    enableNextButton(){
      if (!this.buttonNext()) return;
      if (this.buttonNext().nativeElement.classList.contains('disabled'))
        this.buttonNext().nativeElement.classList.remove('disabled')
    }

    disablePrevButton(){
      if (!this.buttonPrev()) return;
      if (!this.buttonPrev().nativeElement.classList.contains('disabled'))
        this.buttonPrev().nativeElement.classList.add('disabled')
    }

    enablePrevButton(){
      if (!this.buttonPrev()) return;
      if (this.buttonPrev().nativeElement.classList.contains('disabled'))
        this.buttonPrev().nativeElement.classList.remove('disabled')
    }
}